const FormResources = {
    form_data_building_usage_report: {
        report_type: 1,
        building_id: [],
        room_type_id: []
    },
    form_format_building_usage_report: [
        {
            css_class:  'col-md-2',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Report Type:',
            model_name: 'report_type',
            ref:        'report_type_input',
            ref_alt:    'report_type_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-2',
            type:       'infinite-scroll-list',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Building:',
            model_name: 'building_id',
            ref:        'building_id_input',
            ref_alt:    'building_id_input_alt',
            required:   false,
            search: false,
            parent_class: 'custom-control custom-checkbox w-100',
            input_type: 'checkbox',
            input_class: 'custom-control-input',
            label_input_class: 'custom-control-label reports__show-hide__label ml-2',
            placeholder: 'Select building(s)',
            close_on_option: false,
            enable_check_all: true,
            track_by: 'name'
        },
        {
            css_class:  'col-md-2',
            type:       'infinite-scroll-list',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Room Type:',
            model_name: 'room_type_id',
            ref:        'room_type_id_input',
            ref_alt:    'room_type_id_input_alt',
            required:   false,
            search: false,
            parent_class: 'custom-control custom-checkbox w-100',
            input_type: 'checkbox',
            input_class: 'custom-control-input',
            label_input_class: 'custom-control-label reports__show-hide__label ml-2',
            placeholder: 'Select Room Type(s)',
            close_on_option: false,
            enable_check_all: true,
            track_by: 'name'
        },
    ]
}


export default FormResources;